import wavePulseSvg from '@/images/wave-pulse.svg';

const Q1 = 0.25;
const Q2 = 0.25;

export const ChartDefaults = {
    SHOW_Y_GRID: true,
    PERCENTILE_FACTOR: 0.875, // was at 0.9
    CHART_LABEL: 'Usage (units)', // Optional

    // NEW: tuning for break placement (all optional with sane fallbacks)
    EXTREME: {
        PERCENTILES: {
            Q1: Q1,     // used to compute Q1
            Q3: 1 - Q1, // used to compute Q3
            CAP: 1.0,   // cap the break start at P95 of full data
        },
        IQR_MULTIPLIER: 1.5, // Tukey upper fence: Q3 + k*IQR

        // Small padding above cluster peak / Q3 when positioning the break
        BREAK_PADS: {
            INLIER_MAX: 0.05, // 5% above inlier max
            Q3: 0.10,         // 10% above Q3
        },
    },

    // NEW: MODERATE (yellow) tuning — reused algorithm, different knobs
    MODERATE: {
        PERCENTILES: {
            Q1: Q2,
            Q3: 1 - Q2,
            CAP: 1.0
        }, // slightly lower cap
        IQR_MULTIPLIER: 1.5,
        BREAK_PADS: {
            INLIER_MAX: 0.03,
            Q3: 0.06
        }, // tighter pads
    },

    BREAK_SVG_SRC: wavePulseSvg,
    WRAPPER_CLASSES: {
        topChartWrapper: 'top-chart-wrapper',
        bottomChartWrapper: 'bottom-chart-wrapper'
    },
    CHART_COLORS: {
        EXTREME: 'rgba(255, 99, 132, 0.8)',   // Red
        MODERATE: 'rgba(255, 193, 7, 0.8)',   // Yellow
        NORMAL: 'rgba(10, 141, 175, 0.7)',    // Blue
        TRANSPARENT: 'rgba(0, 0, 0, 0)',       // Hidden (top chart)
        MISSING: 'rgb(97, 102, 108)',
    }
};
